var _marker, _marker2, _marker3, _marker4, _marker5, _rect, _rect2, _text, _text2, _line, _rect3, _text3, _rect4, _text4, _line2, _circle, _text5, _circle2, _text6, _line3, _rect5, _text7, _line4, _circle3, _text8, _circle4, _text9, _line5, _rect6, _text0, _line6, _circle5, _text1, _circle6, _text10, _line7, _rect7, _text11, _text12, _line8, _circle7, _text13, _circle8, _text14, _line9, _rect8, _text15, _text16, _line0, _circle9, _text17, _circle0, _text18, _path, _text19, _rect9, _text20, _rect0, _text21, _line1, _circle1, _text22, _circle10, _text23, _line10, _rect1, _text24, _text25, _line11, _circle11, _text26, _circle12, _text27, _line12, _rect10, _text28, _text29, _line13, _circle13, _text30, _circle14, _text31, _line14, _rect11, _text32, _line15, _circle15, _text33, _circle16, _text34, _line16, _rect12, _text35, _line17, _circle17, _text36, _circle18, _text37, _line18, _text38, _rect13, _text39, _line19, _circle19, _text40, _circle20, _text41, _rect14, _text42, _line20, _circle21, _text43, _circle22, _text44, _rect15, _text45, _line21, _circle23, _text46, _circle24, _text47, _rect16, _text48, _line22, _circle25, _text49, _circle26, _text50, _line23, _text51, _line24, _text52, _line25, _text53, _line26, _text54, _line27, _text55, _line28, _text56;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRagPipeline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 960,
    height: 620,
    viewBox: "0 0 960 620",
    xmlns: "http://www.w3.org/2000/svg",
    fontFamily: "Inter, system-ui, sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _marker || (_marker = /*#__PURE__*/React.createElement("marker", {
    id: "mc",
    markerWidth: 8,
    markerHeight: 8,
    refX: 8,
    refY: 3,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,6 L8,3 z",
    fill: "#06B6D4"
  }))), _marker2 || (_marker2 = /*#__PURE__*/React.createElement("marker", {
    id: "mg",
    markerWidth: 8,
    markerHeight: 8,
    refX: 8,
    refY: 3,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,6 L8,3 z",
    fill: "#22c55e"
  }))), _marker3 || (_marker3 = /*#__PURE__*/React.createElement("marker", {
    id: "mv",
    markerWidth: 8,
    markerHeight: 8,
    refX: 8,
    refY: 3,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,6 L8,3 z",
    fill: "#a78bfa"
  }))), _marker4 || (_marker4 = /*#__PURE__*/React.createElement("marker", {
    id: "mo",
    markerWidth: 8,
    markerHeight: 8,
    refX: 8,
    refY: 3,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,6 L8,3 z",
    fill: "#f59e0b"
  }))), _marker5 || (_marker5 = /*#__PURE__*/React.createElement("marker", {
    id: "mp",
    markerWidth: 8,
    markerHeight: 8,
    refX: 8,
    refY: 3,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,6 L8,3 z",
    fill: "#f472b6"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#0c1628"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#060c14"
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 960,
    height: 620,
    fill: "url(#bg)",
    rx: 12
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 960,
    height: 620,
    fill: "none",
    rx: 12,
    stroke: "rgba(255,255,255,0.06)",
    strokeWidth: 1
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 480,
    y: 34,
    textAnchor: "middle",
    fill: "#e2e8f0",
    fontSize: 15,
    fontWeight: 700,
    letterSpacing: -0.3
  }, "RAG AI Assistant \u2014 Production Pipeline")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 480,
    y: 51,
    textAnchor: "middle",
    fill: "#7dd3fc",
    fontSize: 9.5
  }, "text-embedding-3-small \xB7 GPT-4o-mini \xB7 ChromaDB \xB7 FastAPI \xB7 Google Cloud Run")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 63,
    x2: 920,
    y2: 63,
    stroke: "rgba(255,255,255,0.07)",
    strokeWidth: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 70,
    width: 932,
    height: 148,
    rx: 8,
    fill: "rgba(6,182,212,0.02)",
    stroke: "#06B6D4",
    strokeWidth: 1,
    strokeDasharray: "6,4"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 28,
    y: 85,
    fill: "#0e7490",
    fontSize: 8.5,
    fontStyle: "italic",
    fontWeight: 600
  }, "INGESTION \u2014 offline, runs once per document update")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 93,
    width: 152,
    height: 74,
    rx: 6,
    fill: "#0a1628",
    stroke: "#475569",
    strokeWidth: 1.5
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 98,
    y: 112,
    textAnchor: "middle",
    fill: "#94a3b8",
    fontSize: 10,
    fontWeight: 700
  }, "Documents")), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 34,
    y1: 118,
    x2: 162,
    y2: 118,
    stroke: "rgba(71,85,105,0.2)",
    strokeWidth: 1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 130,
    r: 2.5,
    fill: "#475569",
    opacity: 0.8
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 43,
    y: 134,
    fill: "#64748b",
    fontSize: 8.5
  }, "PDF files (pypdf)")), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 147,
    r: 2.5,
    fill: "#475569",
    opacity: 0.8
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 43,
    y: 151,
    fill: "#64748b",
    fontSize: 8.5
  }, "TXT files")), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 174,
    y1: 130,
    x2: 196,
    y2: 130,
    stroke: "#06B6D4",
    strokeWidth: 1.5,
    markerEnd: "url(#mc)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 93,
    width: 152,
    height: 74,
    rx: 6,
    fill: "#0a1628",
    stroke: "#06B6D4",
    strokeWidth: 1.5
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 274,
    y: 112,
    textAnchor: "middle",
    fill: "#06B6D4",
    fontSize: 10,
    fontWeight: 700
  }, "Extract &amp; Clean")), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 210,
    y1: 118,
    x2: 338,
    y2: 118,
    stroke: "rgba(6,182,212,0.12)",
    strokeWidth: 1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 130,
    r: 2.5,
    fill: "#06B6D4",
    opacity: 0.7
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 219,
    y: 134,
    fill: "#cbd5e1",
    fontSize: 8.5
  }, "pypdf \u2014 PDF text extraction")), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 147,
    r: 2.5,
    fill: "#06B6D4",
    opacity: 0.7
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 219,
    y: 151,
    fill: "#cbd5e1",
    fontSize: 8.5
  }, "ftfy \u2014 encoding repair")), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 350,
    y1: 130,
    x2: 372,
    y2: 130,
    stroke: "#06B6D4",
    strokeWidth: 1.5,
    markerEnd: "url(#mc)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 374,
    y: 93,
    width: 152,
    height: 74,
    rx: 6,
    fill: "#0a1628",
    stroke: "#06B6D4",
    strokeWidth: 1.5
  })), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 450,
    y: 112,
    textAnchor: "middle",
    fill: "#06B6D4",
    fontSize: 10,
    fontWeight: 700
  }, "Recursive Chunking")), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 386,
    y1: 118,
    x2: 514,
    y2: 118,
    stroke: "rgba(6,182,212,0.12)",
    strokeWidth: 1
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 386,
    cy: 130,
    r: 2.5,
    fill: "#06B6D4",
    opacity: 0.7
  })), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 395,
    y: 134,
    fill: "#cbd5e1",
    fontSize: 8.5
  }, "Overlap \xB7 sentence boundaries")), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 386,
    cy: 147,
    r: 2.5,
    fill: "#06B6D4",
    opacity: 0.7
  })), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 395,
    y: 151,
    fill: "#cbd5e1",
    fontSize: 8.5
  }, "Header / footer dedup")), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 526,
    y1: 130,
    x2: 548,
    y2: 130,
    stroke: "#a78bfa",
    strokeWidth: 1.5,
    markerEnd: "url(#mv)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 550,
    y: 93,
    width: 182,
    height: 74,
    rx: 6,
    fill: "#0a1628",
    stroke: "#a78bfa",
    strokeWidth: 1.5
  })), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 641,
    y: 109,
    textAnchor: "middle",
    fill: "#a78bfa",
    fontSize: 10,
    fontWeight: 700
  }, "OpenAI Embeddings")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 641,
    y: 121,
    textAnchor: "middle",
    fill: "#6d4fa0",
    fontSize: 8
  }, "text-embedding-3-small \xB7 1536-dim")), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 562,
    y1: 127,
    x2: 720,
    y2: 127,
    stroke: "rgba(167,139,250,0.12)",
    strokeWidth: 1
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 562,
    cy: 139,
    r: 2.5,
    fill: "#a78bfa",
    opacity: 0.7
  })), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 571,
    y: 143,
    fill: "#cbd5e1",
    fontSize: 8.5
  }, "Semantic vector per chunk")), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 562,
    cy: 155,
    r: 2.5,
    fill: "#a78bfa",
    opacity: 0.7
  })), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 571,
    y: 159,
    fill: "#cbd5e1",
    fontSize: 8.5
  }, "Metadata: source \xB7 page \xB7 year")), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 732,
    y1: 130,
    x2: 754,
    y2: 130,
    stroke: "#22c55e",
    strokeWidth: 1.5,
    markerEnd: "url(#mg)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 756,
    y: 93,
    width: 172,
    height: 74,
    rx: 6,
    fill: "#0a1628",
    stroke: "#22c55e",
    strokeWidth: 1.5
  })), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 842,
    y: 112,
    textAnchor: "middle",
    fill: "#22c55e",
    fontSize: 10,
    fontWeight: 700
  }, "ChromaDB")), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 842,
    y: 124,
    textAnchor: "middle",
    fill: "#166534",
    fontSize: 8
  }, "local vector database")), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    x1: 768,
    y1: 130,
    x2: 916,
    y2: 130,
    stroke: "rgba(34,197,94,0.12)",
    strokeWidth: 1
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 768,
    cy: 141,
    r: 2.5,
    fill: "#22c55e",
    opacity: 0.7
  })), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 777,
    y: 145,
    fill: "#cbd5e1",
    fontSize: 8.5
  }, "Vectors + text stored")), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 768,
    cy: 157,
    r: 2.5,
    fill: "#22c55e",
    opacity: 0.7
  })), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 777,
    y: 161,
    fill: "#cbd5e1",
    fontSize: 8.5
  }, "chroma.sqlite3 \xB7 .bin vectors")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 842 167 L 842 238 L 450 238 L 450 278",
    fill: "none",
    stroke: "#22c55e",
    strokeWidth: 1.5,
    strokeDasharray: "5,3",
    markerEnd: "url(#mg)"
  })), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 648,
    y: 234,
    textAnchor: "middle",
    fill: "#166534",
    fontSize: 8,
    fontStyle: "italic"
  }, "shared index")), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 254,
    width: 932,
    height: 148,
    rx: 8,
    fill: "rgba(167,139,250,0.02)",
    stroke: "#a78bfa",
    strokeWidth: 1,
    strokeDasharray: "6,4"
  })), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 28,
    y: 269,
    fill: "#6d4fa0",
    fontSize: 8.5,
    fontStyle: "italic",
    fontWeight: 600
  }, "QUERY \u2014 real-time, per request")), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 278,
    width: 152,
    height: 74,
    rx: 6,
    fill: "#0a1628",
    stroke: "#f472b6",
    strokeWidth: 1.5
  })), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    x: 98,
    y: 297,
    textAnchor: "middle",
    fill: "#f472b6",
    fontSize: 10,
    fontWeight: 700
  }, "User Query")), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    x1: 34,
    y1: 303,
    x2: 162,
    y2: 303,
    stroke: "rgba(244,114,182,0.12)",
    strokeWidth: 1
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 315,
    r: 2.5,
    fill: "#f472b6",
    opacity: 0.7
  })), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 43,
    y: 319,
    fill: "#cbd5e1",
    fontSize: 8.5
  }, "Plain language question")), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 332,
    r: 2.5,
    fill: "#f472b6",
    opacity: 0.7
  })), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    x: 43,
    y: 336,
    fill: "#cbd5e1",
    fontSize: 8.5
  }, "lang: en | es \xB7 history")), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 174,
    y1: 315,
    x2: 196,
    y2: 315,
    stroke: "#a78bfa",
    strokeWidth: 1.5,
    markerEnd: "url(#mv)"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 278,
    width: 152,
    height: 74,
    rx: 6,
    fill: "#0a1628",
    stroke: "#a78bfa",
    strokeWidth: 1.5
  })), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    x: 274,
    y: 294,
    textAnchor: "middle",
    fill: "#a78bfa",
    fontSize: 10,
    fontWeight: 700
  }, "Embed Query")), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    x: 274,
    y: 306,
    textAnchor: "middle",
    fill: "#6d4fa0",
    fontSize: 8
  }, "same model \xB7 same space")), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 210,
    y1: 312,
    x2: 338,
    y2: 312,
    stroke: "rgba(167,139,250,0.12)",
    strokeWidth: 1
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 324,
    r: 2.5,
    fill: "#a78bfa",
    opacity: 0.7
  })), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    x: 219,
    y: 328,
    fill: "#cbd5e1",
    fontSize: 8.5
  }, "text-embedding-3-small")), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 340,
    r: 2.5,
    fill: "#a78bfa",
    opacity: 0.7
  })), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
    x: 219,
    y: 344,
    fill: "#cbd5e1",
    fontSize: 8.5
  }, "1536-dim query vector")), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 350,
    y1: 315,
    x2: 372,
    y2: 315,
    stroke: "#22c55e",
    strokeWidth: 1.5,
    markerEnd: "url(#mg)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 374,
    y: 278,
    width: 162,
    height: 74,
    rx: 6,
    fill: "#0a1628",
    stroke: "#22c55e",
    strokeWidth: 1.5
  })), _text28 || (_text28 = /*#__PURE__*/React.createElement("text", {
    x: 455,
    y: 294,
    textAnchor: "middle",
    fill: "#22c55e",
    fontSize: 10,
    fontWeight: 700
  }, "Retrieve + Filter")), _text29 || (_text29 = /*#__PURE__*/React.createElement("text", {
    x: 455,
    y: 306,
    textAnchor: "middle",
    fill: "#166534",
    fontSize: 8
  }, "ChromaDB \xB7 cosine similarity")), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 386,
    y1: 312,
    x2: 524,
    y2: 312,
    stroke: "rgba(34,197,94,0.12)",
    strokeWidth: 1
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 386,
    cy: 324,
    r: 2.5,
    fill: "#22c55e",
    opacity: 0.7
  })), _text30 || (_text30 = /*#__PURE__*/React.createElement("text", {
    x: 395,
    y: 328,
    fill: "#7dd3fc",
    fontSize: 8.5
  }, "Top-K by similarity score")), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 386,
    cy: 340,
    r: 2.5,
    fill: "#22c55e",
    opacity: 0.7
  })), _text31 || (_text31 = /*#__PURE__*/React.createElement("text", {
    x: 395,
    y: 344,
    fill: "#7dd3fc",
    fontSize: 8.5
  }, "Per-source diversity cap")), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 536,
    y1: 315,
    x2: 558,
    y2: 315,
    stroke: "#f59e0b",
    strokeWidth: 1.5,
    markerEnd: "url(#mo)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 560,
    y: 278,
    width: 172,
    height: 74,
    rx: 6,
    fill: "#0a1628",
    stroke: "#f59e0b",
    strokeWidth: 1.5
  })), _text32 || (_text32 = /*#__PURE__*/React.createElement("text", {
    x: 646,
    y: 297,
    textAnchor: "middle",
    fill: "#f59e0b",
    fontSize: 10,
    fontWeight: 700
  }, "GPT-4o-mini")), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 572,
    y1: 303,
    x2: 720,
    y2: 303,
    stroke: "rgba(245,158,11,0.12)",
    strokeWidth: 1
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 572,
    cy: 315,
    r: 2.5,
    fill: "#f59e0b",
    opacity: 0.7
  })), _text33 || (_text33 = /*#__PURE__*/React.createElement("text", {
    x: 581,
    y: 319,
    fill: "#cbd5e1",
    fontSize: 8.5
  }, "Context-grounded generation")), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 572,
    cy: 331,
    r: 2.5,
    fill: "#f59e0b",
    opacity: 0.7
  })), _text34 || (_text34 = /*#__PURE__*/React.createElement("text", {
    x: 581,
    y: 335,
    fill: "#cbd5e1",
    fontSize: 8.5
  }, "Answer from context only")), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 732,
    y1: 315,
    x2: 754,
    y2: 315,
    stroke: "#f59e0b",
    strokeWidth: 1.5,
    markerEnd: "url(#mo)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 756,
    y: 278,
    width: 172,
    height: 74,
    rx: 6,
    fill: "#0a1628",
    stroke: "#f59e0b",
    strokeWidth: 1.5
  })), _text35 || (_text35 = /*#__PURE__*/React.createElement("text", {
    x: 842,
    y: 297,
    textAnchor: "middle",
    fill: "#f59e0b",
    fontSize: 10,
    fontWeight: 700
  }, "Answer + Citations")), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 768,
    y1: 303,
    x2: 916,
    y2: 303,
    stroke: "rgba(245,158,11,0.12)",
    strokeWidth: 1
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 768,
    cy: 315,
    r: 2.5,
    fill: "#f59e0b",
    opacity: 0.7
  })), _text36 || (_text36 = /*#__PURE__*/React.createElement("text", {
    x: 777,
    y: 319,
    fill: "#cbd5e1",
    fontSize: 8.5
  }, "Grounded cited response")), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 768,
    cy: 331,
    r: 2.5,
    fill: "#f59e0b",
    opacity: 0.7
  })), _text37 || (_text37 = /*#__PURE__*/React.createElement("text", {
    x: 777,
    y: 335,
    fill: "#cbd5e1",
    fontSize: 8.5
  }, "Source \xB7 page \xB7 score")), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 420,
    x2: 920,
    y2: 420,
    stroke: "rgba(255,255,255,0.06)",
    strokeWidth: 1
  })), _text38 || (_text38 = /*#__PURE__*/React.createElement("text", {
    x: 480,
    y: 437,
    textAnchor: "middle",
    fill: "#334155",
    fontSize: 8.5,
    fontWeight: 600,
    letterSpacing: 1
  }, "INFRASTRUCTURE")), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 448,
    width: 196,
    height: 58,
    rx: 6,
    fill: "#0a1628",
    stroke: "#06B6D4",
    strokeWidth: 1.5
  })), _text39 || (_text39 = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 466,
    textAnchor: "middle",
    fill: "#06B6D4",
    fontSize: 10,
    fontWeight: 700
  }, "FastAPI + Uvicorn")), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 34,
    y1: 472,
    x2: 206,
    y2: 472,
    stroke: "rgba(6,182,212,0.1)",
    strokeWidth: 1
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 482,
    r: 2,
    fill: "#06B6D4",
    opacity: 0.7
  })), _text40 || (_text40 = /*#__PURE__*/React.createElement("text", {
    x: 42,
    y: 486,
    fill: "#64748b",
    fontSize: 8
  }, "REST API \xB7 per-IP rate limiting")), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 497,
    r: 2,
    fill: "#06B6D4",
    opacity: 0.7
  })), _text41 || (_text41 = /*#__PURE__*/React.createElement("text", {
    x: 42,
    y: 501,
    fill: "#64748b",
    fontSize: 8
  }, "/ask \xB7 /docs \xB7 input validation")), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 448,
    width: 220,
    height: 58,
    rx: 6,
    fill: "#0a1628",
    stroke: "#22c55e",
    strokeWidth: 1.5
  })), _text42 || (_text42 = /*#__PURE__*/React.createElement("text", {
    x: 342,
    y: 466,
    textAnchor: "middle",
    fill: "#22c55e",
    fontSize: 10,
    fontWeight: 700
  }, "Docker \u2192 Cloud Run")), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 244,
    y1: 472,
    x2: 440,
    y2: 472,
    stroke: "rgba(34,197,94,0.1)",
    strokeWidth: 1
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 244,
    cy: 482,
    r: 2,
    fill: "#22c55e",
    opacity: 0.7
  })), _text43 || (_text43 = /*#__PURE__*/React.createElement("text", {
    x: 252,
    y: 486,
    fill: "#64748b",
    fontSize: 8
  }, "Serverless \xB7 autoscaling \xB7 zero cold-start")), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 244,
    cy: 497,
    r: 2,
    fill: "#22c55e",
    opacity: 0.7
  })), _text44 || (_text44 = /*#__PURE__*/React.createElement("text", {
    x: 252,
    y: 501,
    fill: "#64748b",
    fontSize: 8
  }, "Artifact Registry \xB7 gcloud CLI deploy")), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 466,
    y: 448,
    width: 210,
    height: 58,
    rx: 6,
    fill: "#0a1628",
    stroke: "#f59e0b",
    strokeWidth: 1.5
  })), _text45 || (_text45 = /*#__PURE__*/React.createElement("text", {
    x: 571,
    y: 466,
    textAnchor: "middle",
    fill: "#f59e0b",
    fontSize: 10,
    fontWeight: 700
  }, "Secret Manager")), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 478,
    y1: 472,
    x2: 664,
    y2: 472,
    stroke: "rgba(245,158,11,0.1)",
    strokeWidth: 1
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 478,
    cy: 482,
    r: 2,
    fill: "#f59e0b",
    opacity: 0.7
  })), _text46 || (_text46 = /*#__PURE__*/React.createElement("text", {
    x: 486,
    y: 486,
    fill: "#64748b",
    fontSize: 8
  }, "OpenAI key injected at runtime")), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 478,
    cy: 497,
    r: 2,
    fill: "#f59e0b",
    opacity: 0.7
  })), _text47 || (_text47 = /*#__PURE__*/React.createElement("text", {
    x: 486,
    y: 501,
    fill: "#64748b",
    fontSize: 8
  }, "Never baked into Docker image")), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 690,
    y: 448,
    width: 248,
    height: 58,
    rx: 6,
    fill: "#0a1628",
    stroke: "#a78bfa",
    strokeWidth: 1.5
  })), _text48 || (_text48 = /*#__PURE__*/React.createElement("text", {
    x: 814,
    y: 466,
    textAnchor: "middle",
    fill: "#a78bfa",
    fontSize: 10,
    fontWeight: 700
  }, "Cloud Storage \u2014 Logs")), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 702,
    y1: 472,
    x2: 926,
    y2: 472,
    stroke: "rgba(167,139,250,0.1)",
    strokeWidth: 1
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 702,
    cy: 482,
    r: 2,
    fill: "#a78bfa",
    opacity: 0.7
  })), _text49 || (_text49 = /*#__PURE__*/React.createElement("text", {
    x: 710,
    y: 486,
    fill: "#64748b",
    fontSize: 8
  }, "Per-request JSON \xB7 by date")), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 702,
    cy: 497,
    r: 2,
    fill: "#a78bfa",
    opacity: 0.7
  })), _text50 || (_text50 = /*#__PURE__*/React.createElement("text", {
    x: 710,
    y: 501,
    fill: "#64748b",
    fontSize: 8
  }, "Full audit trail \xB7 async write")), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 570,
    x2: 42,
    y2: 570,
    stroke: "#06B6D4",
    strokeWidth: 2
  })), _text51 || (_text51 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 574,
    fill: "#475569",
    fontSize: 8.5
  }, "ingestion flow")), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 148,
    y1: 570,
    x2: 168,
    y2: 570,
    stroke: "#a78bfa",
    strokeWidth: 1.5
  })), _text52 || (_text52 = /*#__PURE__*/React.createElement("text", {
    x: 174,
    y: 574,
    fill: "#475569",
    fontSize: 8.5
  }, "query flow")), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 254,
    y1: 570,
    x2: 274,
    y2: 570,
    stroke: "#22c55e",
    strokeWidth: 1.5
  })), _text53 || (_text53 = /*#__PURE__*/React.createElement("text", {
    x: 280,
    y: 574,
    fill: "#475569",
    fontSize: 8.5
  }, "ChromaDB (shared index)")), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    x1: 434,
    y1: 570,
    x2: 454,
    y2: 570,
    stroke: "#22c55e",
    strokeWidth: 1.5,
    strokeDasharray: "5,3"
  })), _text54 || (_text54 = /*#__PURE__*/React.createElement("text", {
    x: 460,
    y: 574,
    fill: "#475569",
    fontSize: 8.5
  }, "shared index connector")), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    x1: 622,
    y1: 570,
    x2: 642,
    y2: 570,
    stroke: "#f59e0b",
    strokeWidth: 1.5
  })), _text55 || (_text55 = /*#__PURE__*/React.createElement("text", {
    x: 648,
    y: 574,
    fill: "#475569",
    fontSize: 8.5
  }, "generation flow")), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    x1: 750,
    y1: 570,
    x2: 770,
    y2: 570,
    stroke: "#f472b6",
    strokeWidth: 1.5
  })), _text56 || (_text56 = /*#__PURE__*/React.createElement("text", {
    x: 776,
    y: 574,
    fill: "#475569",
    fontSize: 8.5
  }, "user interaction")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRagPipeline);
export default __webpack_public_path__ + "static/media/rag-pipeline.78348931b59e184d1f2135a809617568.svg";
export { ForwardRef as ReactComponent };